import { useEffect, useMemo } from 'react';

export const useObjectUrl = (obj: Blob | MediaSource): string => {
  const url = useMemo(() => URL.createObjectURL(obj), [obj]);

  useEffect(() => () => URL.revokeObjectURL(url), [url]);

  return url;
};
